//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SourceSupBase from '../source-common-module/source-sup-base';
import SourceMaterial from '../source-common-module/source-material';
import SourceBusiness from '../source-common-module/source-business';
import SourceAttach from '../source-common-module/source-attach';
import SourceNotice from '../source-common-module/source-notice';
import SourceQuestion from '../source-common-module/source-question';
export default {
  name: "source-sup-item",
  components:{
    SourceSupBase,
    SourceMaterial,
    SourceBusiness,
    SourceAttach,
    SourceNotice,
    SourceQuestion
  },
  data(){
    return{
      sourceId: null,
      sourceDto:{},
      selectModel:'base',
      defaultPar:{},
      priceTemplateList:[],
      rotation:{},
      contact:{},
      supplierId:null,
      canOffer:false,
      viewOfferRound:null,
      toEnroll:false,
      sourceNormalQuote:{}
    }
  },
  methods:{
    backSourceList(){
      this.$router.go(-1);
    },
    getSourceDto(){
      this.$loadingShow();
      this.$get(`api/source/${this.sourceId}`).then((res) => {
        if(res){
          this.sourceDto = res;
          this.sourceDto.sourceMaterialDtList = this.sourceDto.sourceMaterialDtList.filter((item) => {
            return item.enable;
          });
          this.sourceDto.sourceRotationList = this.sourceDto.sourceRotationList.sort((a,b) => a.round - b.round);
          this.priceTemplateList = (this.sourceDto.priceTemplete && this.sourceDto.priceTemplete.sptQuoteFieldList) || [];
          this.priceTemplateList.sort((a, b) => a.sort - b.sort);
          this.rotation = this.sourceDto.sourceRotationList[this.sourceDto.currentRound-1];
          this.getDefault();
          if(this.sourceDto.stage === 'offer' && this.supplierId){
            this.offerOper();
            this.getNormalQuote()
          }
          this.getAttachmentList();
        }
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    getDefault(){
      if(this.sourceDto.sourceType){
        this.$loadingShow();
        this.$get(`api/sourceType/${this.sourceDto.sourceType.id}`).then((res) => {
          for(let k in res){
            if(res[k] && res[k].defaultValue){
              if(res[k].defaultValue === 'true'){
                res[k].defaultValue = true;
              }else if(res[k].defaultValue === 'false'){
                res[k].defaultValue = false;
              }
            }
          }
          this.defaultPar = res;
          this.copyTemplateToDefaultPar();
          this.$loadingHide();
        }).catch(() => {
          this.$loadingHide();
        })
      }
    },
    copyTemplateToDefaultPar(){
      this.defaultPar.materialType = this.sourceDto.priceTemplete.materialType;
      this.defaultPar.demandQuantity = this.sourceDto.priceTemplete.demandQuantity;
      this.defaultPar.baseUnit = this.sourceDto.priceTemplete.baseUnit;
      this.defaultPar.matPlant = this.sourceDto.priceTemplete.matPlant;
      this.defaultPar.matDemandDate = this.sourceDto.priceTemplete.matDemandDate;
      this.defaultPar.matPurchaseNum = this.sourceDto.priceTemplete.matPurchaseNum;
      this.defaultPar.matRemark = this.sourceDto.priceTemplete.matRemark;
      this.defaultPar.matAttach = this.sourceDto.priceTemplete.matAttach;
    },
    changeShowModel(str){
      this.selectModel = str;
    },
    getSupId(){
      this.$loadingShow();
      this.$get('api/supplier/current-sample').then((res) => {
        this.supplierId = res.id;
        this.$loadingHide();
        this.getContact();
        if(this.sourceDto.stage === 'offer' && this.supplierId){
          this.offerOper();
        }
      }).catch(() => {
        this.$loadingHide();
      })
    },
    getContact(){
      this.$loadingShow();
      this.$get(`api/sourceEnroll/enroll-by-source-id-sup?sourcingId=${this.sourceId}&supplierId=${this.supplierId}`).then((res) => {
        if(!res.attachment){
          res.attachment = {};
        }
        if(!res.depositAttachment){
          res.depositAttachment = {};
        }
        if(!res.feeAttachment){
          res.feeAttachment = {};
        }
        this.contact = res;
        this.getAttachmentList();
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    offerOper(){
      this.$loadingShow();
      this.$get('api/source/check-sup',{supId:this.supplierId,id:this.sourceId}).then((res) => {
        this.canOffer = res.canOffer;
        this.viewOfferRound = res.round;
        this.toEnroll = res.toEnroll;
      })
    },
    giveUpEnroll(){
      let that = this;
      this.$vux.confirm.show({
        title: '确认放弃该寻源项目？',
        onConfirm:() => {
          that.$loadingShow();
          console.log(this.sourceId);
          that.$get('api/sourceEnroll/give-up',{id:this.sourceId}).then((res) => {
            this.$vux.toast.text('已放弃该寻源项目');
            this.updateContact();
          }).catch(() => {
            this.$loadingHide();
          });
        }
      });
    },
    updateContact(){
      this.getContact();
      if(this.sourceDto.stage === 'offer'){
        this.offerOper();
        this.getNormalQuote();
      }
    },
    goOffer(){
      if(this.canOffer && this.sourceDto.status === 'going'){
        this.$router.push(`/sup-offer/${this.sourceId}`);
      }else{
        this.$router.push(`/view-offer/${this.sourceId}/${this.viewOfferRound}/${this.supplierId}`);
      }
    },
    getNormalQuote(){
      let obj = {
        id:this.sourceId,
        round:this.sourceDto.currentRound,
        supId:this.supplierId
      };
      this.$get('api/sourceNormalQuote/round',obj).then((data) => {
        this.sourceNormalQuote = data;
      })
    },
    giveUpOffer(){
      this.$vux.confirm.show({
        title: '确认放弃本轮对物料的报价？',
        onConfirm:() => {
          this.$loadingShow();
          this.$get(`api/sourceNormalQuote/give-up-one?sourceId=${this.sourceId}&supperId=${this.supplierId}`).then(() => {
            this.$vux.toast.text('放弃成功');
            this.updateContact();
            this.$loadingHide();
          }).catch(() => {
            this.$loadingHide();
          });
        }
      })
    },
    getAttachmentList(){
      if(this.sourceDto.attachmentList && this.contact.id){
        this.sourceDto.attachmentList = this.sourceDto.attachmentList.filter(item => item.supViewAuthority !== 'authorityIntenalVisibility');
        if(this.contact.needEnroll){
          if(!this.contact.enroll){
            this.sourceDto.attachmentList = this.sourceDto.attachmentList.filter(item => item.supViewAuthority !== 'authorityPass')
          }
          if(this.contact.enrollQualPass !== 'enrollPass'){
            this.sourceDto.attachmentList = this.sourceDto.attachmentList.filter(item => item.supViewAuthority !== 'authorityPass')
          }
        }
      }
    },
    viewSupOffer(){
      let viewRound = this.sourceDto.currentRound;
      if(this.viewOfferRound){
        viewRound = this.viewOfferRound;
      }
      this.$router.push(`/view-offer/${this.sourceId}/${viewRound}/${this.supplierId}`);
    },
    supEnroll(){
      if(this.contact.supstaName === '注册'){
        this.$vux.toast.text('请完成资料补充并通过审核后，才可参与寻源');
        return;
      }
      if(this.contact.supstaName === '停用' || this.contact.supstaName === '黑名单'){
        this.$vux.toast.text('当前状态不可参与寻源');
        return;
      }
      if(!this.contact.contactName){
        this.$vux.toast.text('请补充基本信息中的销售人员');
        this.selectModel = 'base';
        return;
      }
      if(this.sourceDto.enablePrequalification){
        if(!(this.contact.attachment && this.contact.attachment.attachFile && this.contact.attachment.attachFile.length)){
          this.$vux.toast.text('请上传资质文件');
          this.selectModel = 'base';
          return;
        }
      }
      if(this.sourceDto.enableDeposit){
        if(!(this.contact.depositAttachment && this.contact.depositAttachment.attachFile && this.contact.depositAttachment.attachFile.length)){
          this.$vux.toast.text('请上传保证金的付款凭证');
          this.selectModel = 'base';
          return;
        }
      }
      if(this.sourceDto.enableTenderFee){
        if(!(this.contact.feeAttachment && this.contact.feeAttachment.attachFile && this.contact.feeAttachment.attachFile.length)){
          this.$vux.toast.text('请上传标书费用的付款凭证');
          this.selectModel = 'base';
          return;
        }
      }
      this.$loadingShow();
      this.$post('api/sourceEnroll/apply',this.contact).then((res) => {
        this.$vux.toast.text('报名成功');
        this.updateContact();
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    },
  },
  mounted(){
    this.sourceId = this.$route.params.id;
    this.getSourceDto();
    this.getSupId();
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-sup/source-sup-item.vue